import React from "react";

const NotFoundPage = (props) => {
  return (
    <section>
      <h2>Page Not Found</h2>
      <p>No page found at this path.</p>
    </section>
  );
};

export default NotFoundPage;
